import styled from '@emotion/styled/macro';

const TITLE_HEIGHT = '20px';
const FOOTER_HEIGHT = '20px';
const ICON_HEIGHT = TITLE_HEIGHT;

export const WorklogItem = styled.div`
  @keyframes grayWhite {
    0% {
      background-color: transparent;
    }
    50% {
      background-color: #eaecef;
    }
    51% {
      background-color: #eaecef;
    }
    100% {
      background-color: transparent;
    }
  }

  color: ${({ theme }) => theme.colors.primary};
  display: flex;
  flex-direction: row;
  padding: 4px 4px 0 4px;
  border-radius: 4px;
  animation: ${({ isSelected }) =>
    isSelected ? 'grayWhite 6s ease 1' : 'none'};

  background-color: transparent;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: ${({ theme }) =>
      theme.dark ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.05)'};

    /* Overlay color */
    pointer-events: none; /* Allows hover events to pass through */
    opacity: 0; /* Initially transparent */
    transition: opacity 0.3s; /* Transition effect */
  }

  &:hover::after {
    opacity: 1; /* Make the overlay visible on hover */
  }
`;

export const Title = styled.div`
  display: flex;
  height: ${TITLE_HEIGHT};
  line-height: ${TITLE_HEIGHT};
  width: 100%;
  > div:not(:first-of-type) {
    margin-left: 5px;
  }
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 10px 0 5px;
  overflow: hidden;
  flex: 1;
`;

export const Footer = styled.div`
  height: ${FOOTER_HEIGHT};
  line-height: ${FOOTER_HEIGHT};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  color: #5e6c84;
  font-size: 12px;
  margin-top: 5px;
`;

export const FooterInfo = styled.div`
  :first-of-type {
    flex: 1;
    display: flex;

    > div {
      :not(:first-of-type):before {
        margin: 0 4px;
        content: '|';
      }
    }
  }
`;

export const UserName = styled.div`
  font-weight: bold;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  filter: ${({ isLoading }) => (isLoading ? 'blur(3px)' : '')};
`;

export const UserAction = styled.div`
  display: flex;
  white-space: nowrap;
  margin-left: 5px;
  gap: 5px;
`;

export const ActionText = styled.div``;

export const TimerText = styled.div`
  display: flex;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-variant-numeric: tabular-nums;
`;

export const ManagePanel = styled.div`
  display: flex;
  margin-left: auto !important;
  > button {
    > svg {
      height: ${ICON_HEIGHT};
      width: ${ICON_HEIGHT};
    }
  }
`;

export const CardInfo = styled.div`
  display: flex;
  flex: 1;
  min-width: 0; // it's workaround https://css-tricks.com/flexbox-truncated-text/
`;

export const CardName = styled.span`
  margin-left: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
  text-decoration: ${({ textDecoration }) => textDecoration};
`;

export const Comment = styled.div`
  flex-grow: 1;
  // color: #6b778c;
  // color: var(--ds-text-subtle);
  color: ${({ theme }) => theme.colors.secondary};

  ${({ placement, theme }) =>
    placement === 'body' &&
    `
      background-color: ${
        theme.dark ? theme.bgColors.secondary : theme.bgColors.primary
      };
      border-radius: 3px;
      display: inline-block;
      margin: 5px 0;
      // box-shadow: 0 1px 2px -1px var(--ds-border), 0 0 0 1px var(--ds-border);
      box-shadow: 0 1px 2px -1px ${theme.input.border}, 0 0 0 1px ${
      theme.input.border
    };
  `}

  ${({ placement }) =>
    placement === 'title' &&
    `
      margin-left: 4px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      :before {
        content: ' - ';
      }
  `}
`;

export const Dot = styled.div`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  align-self: center;
  background-color: ${({ timerStatus }) =>
    timerStatus === 'pause' ? 'orange' : 'green'};
`;

export const Divider = styled.hr`
  margin: 6px 0 0 0;
  background-color: ${({ theme }) =>
    theme.dark ? '#A6C5E229' : 'rgba(9, 30, 66, 0.13)'};
`;
